import type { GridInterface } from '@ad-lucy/context/adData';

import { defineGrid } from './defineGrid';

export const grid2x1 = (): GridInterface[] =>
  defineGrid(
    '2:1',
    [
      {
        name: 'Sitebar',
        rows: [
          {
            columns: [
              {
                tileId: 0,
              },
              {
                tileId: 1,
              },
            ],
          },
          {
            columns: [
              {
                tileId: 2,
                spanCol: 3,
              },
            ],
          },
        ],
      },
    ],
    2,
    2,
  );
